import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";

import "../../../styles/components/map/filter/FilterType.scss";
import arrow from "../../../styles/images/arrow_black.svg";

class ParkingType extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      collapsed: true,
    };

    this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleOnClickAccordion(e) {
    this.safeSetState(prevState => ({ collapsed: !prevState.collapsed }));
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Accordion id="parkingType">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0" onClick={this.handleOnClickAccordion}>
            <Translate value="mapFilter_parkingType" />
            <img src={arrow} alt="" className={this.state.collapsed ? "arrow" : "arrow open"} />
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <div className="types-container">
                {Object.keys(this.props.parkingTypes).map(k => (
                  <div key={k} className="type" onClick={() => this.props.onParkingTypeClick(k)}>
                    <img
                      src={
                        this.props.parkingTypes[k].picked
                          ? this.props.parkingTypes[k].selected
                          : this.props.parkingTypes[k].faded
                      }
                      alt=""
                    />
                    <p>
                      <Translate value={`parkingType_${this.props.parkingTypes[k].name}`} />
                    </p>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    );
  }
}

export default ParkingType;
